/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.actividad': 'Activity',
'sidebar.clasificaciones': 'Activity',
'clasificaciones.agregarClasificaciones': 'Create Activity',
'clasificaciones.modificarClasificaciones': 'Edit Activity',
'clasificaciones.eliminarClasificaciones': 'Delete Activity',
'clasificaciones.clasificacionId': 'Activity   Id ',
'clasificaciones.empresaId': ' Business   Id ',
'clasificaciones.clasificacionDescripcion': 'Activity  Description',
'clasificaciones.clasificaciones': 'Activity',
'clasificaciones.verClasificaciones': 'View Activity',
};

